import React, { FC, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { ResultModalProps } from '@features/payment/payment-form'
import { PaymentMethod } from '@entities/payment'
import { Modal, ModalWrapper } from '@shared/ui/organisms'

const ResultModal: FC<ResultModalProps> = ({ open, onClose }) => {
  const router = useRouter()

  const [methodPaidBy, setMethodPaidBy] = useState<PaymentMethod | null>(null)

  useEffect(() => {
    setMethodPaidBy(router.query.mdOrder ? PaymentMethod.MTS_ACCOUNT : PaymentMethod.SBP)
  }, [router.query.requestId, router.query.mdOrder])

  return (
    <Modal open={open} onClose={onClose}>
      <ModalWrapper>{methodPaidBy}</ModalWrapper>
    </Modal>
  )
}

export default ResultModal
